module.exports = __webpack_public_path__ + "assets/img/yitianxie Info.79741915.png";